import React, { useState, useEffect,useRef } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table, 
  Container,
  Row,
  Col,
} from "react-bootstrap";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader, 
  CCol,
  CRow, 
  CTable,
  CTableHead, 
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormSelect, 
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CFormCheck,
  CProgress,
  CProgressBar,
  CFormTextarea,
  CSpinner,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster
} from '@coreui/react';
import { fetchAuthSession  } from 'aws-amplify/auth';
import AWS from 'aws-sdk';

function Pro() {

  const REGION ='us-east-1';
  const DYNAMODB_TABLE_NAME = 'codeflex';
  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    }),
  });

  const [email, setEmail] = useState()
  const [usuario, setusuario] = useState()
  const [base,SetDB] = useState();



  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {
          setEmail(data.tokens.idToken.payload.email);
          leerptoyectos(data.tokens.accessToken.payload.username);
          setusuario(data.tokens.accessToken.payload.username);
        });

      } catch (err) {
        console.log(err);
      }

    })();	
	},[]);


  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.epayco.co/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);


  async function leerptoyectos(sub) {
    const params = {
      TableName: DYNAMODB_TABLE_NAME, 
      Key: {
        token: sub,
      },
    };
  
    try {
      const data = await dynamodb.get(params).promise();
      if (data.Item) {
        let validado;
        validado = data.Item.premium;
        SetDB(validado);
      } else {
        console.log('Usuario no encontrado.');
      }
    } catch (err) {
      console.error('Error al buscar usuario:', err);
    }
  }

  const russianDomains = [
    "msu.ru", 
    "spbu.ru", 
    "misis.ru", 
    "mipt.ru", 
    "hse.ru", 
    "spbstu.ru", 
    "kpfu.ru", 
    "nsu.ru"
  ];

  const isRussianEmail = (email) => {
    return russianDomains.some(domain => email.endsWith(domain));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>


      <CCard className="mb-4 ccard-custom-style">
        <CCardHeader>
          <strong>Codeflex PRO ({email})</strong>
        </CCardHeader>
        <CCardBody>
        <CTable responsive className="elegant-table">
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell scope="col">#</CTableHeaderCell>
              <CTableHeaderCell scope="col">FREE</CTableHeaderCell>
              <CTableHeaderCell scope="col">EDU</CTableHeaderCell>
              <CTableHeaderCell scope="col">PRO</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            <CTableRow>
              <CTableDataCell><strong>Almacenamiento</strong></CTableDataCell>
              <CTableDataCell>7GB</CTableDataCell>
              <CTableDataCell>14GB</CTableDataCell>
              <CTableDataCell>300GB</CTableDataCell>
            </CTableRow>
            <CTableRow>
              <CTableDataCell><strong>Acceso a phpMyAdmin</strong></CTableDataCell>
              <CTableDataCell style={{color:"red"}}>✖</CTableDataCell>
              <CTableDataCell style={{color:"green"}}>✔</CTableDataCell>
              <CTableDataCell style={{color:"green"}}>✔</CTableDataCell>
            </CTableRow>
            <CTableRow>
              <CTableDataCell><strong>Codeflex Polly</strong></CTableDataCell>
              <CTableDataCell style={{color:"red"}}>✖</CTableDataCell>
              <CTableDataCell style={{color:"green"}}>✔</CTableDataCell>
              <CTableDataCell style={{color:"green"}}>✔</CTableDataCell>
            </CTableRow>
            <CTableRow>
              <CTableDataCell><strong>Soporte Premium</strong></CTableDataCell>
              <CTableDataCell style={{color:"red"}}>✖</CTableDataCell>
              <CTableDataCell style={{color:"green"}}>✔</CTableDataCell>
              <CTableDataCell style={{color:"green"}}>✔</CTableDataCell>
            </CTableRow>
            <CTableRow>
              <CTableDataCell><strong></strong></CTableDataCell>
              <CTableDataCell style={{color:"blue"}}>Free</CTableDataCell>
              <CTableDataCell style={{color:"blue"}}>Institucional</CTableDataCell>
              <CTableDataCell style={{color:"blue"}}>$14 USD</CTableDataCell>
            </CTableRow>
            <CTableRow>
              <CTableDataCell><strong></strong></CTableDataCell>


              <CTableDataCell>
                {email && (email.endsWith('.edu') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || isRussianEmail(email) || email.endsWith('.edu.ve')) ?
                  <>
                    <CButton
                        className="btn-round btn-fill disabled"
                        href="#"
                        variant="default"
                      >
                        Versión anterior
                    </CButton>
                  </>          
                :
                  <>
                    {base ?
                      <>
                        <CButton
                            className="btn-round btn-fill disabled"
                            href="#"
                            variant="default"
                          >
                            Versión anterior
                        </CButton>
                      </>
                    :
                      <CButton
                        className="btn-round btn-fill disabled"
                        href="#"
                        style={{ border: "2px solid blue",color:"blue"}}
                        variant="default"
                      >
                        Versión actual
                      </CButton>
                    }
                  </>
                }
              </CTableDataCell>


              <CTableDataCell>
                {email && (email.endsWith('.edu') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || isRussianEmail(email) || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve')) ?
                  <>
                    <CButton
                      className="btn-round btn-fill disabled"
                      href="#"
                      style={{ border: "2px solid blue",color:"blue"}}
                      variant="default"
                    >
                      Versión actual
                    </CButton>
                  </>          
                :
                  <>
                    {base ?
                      <>
                        <CButton
                            className="btn-round btn-fill disabled"
                            href="#"
                            variant="default"
                          >
                            Versión anterior
                        </CButton>
                      </>
                    :
                      <>
                        <CButton
                            className="btn-round btn-fill disabled"
                            href="#"
                            variant="default"
                          >
                            Versión anterior
                        </CButton>
                      </>
                    }
                  </>
                }
              </CTableDataCell>


              <CTableDataCell>
                {email && (email.endsWith('.edu') ||  email.endsWith('.edu.co') || email.endsWith('.edu.ar') || isRussianEmail(email) || email.endsWith('.edu.mx') ||  email.endsWith('.edu.es') || email.endsWith('.edu.br') || email.endsWith('.edu.ve')) ?
                    <>
                      <CButton
                          className="btn-round btn-fill disabled"
                          href="#"
                          variant="default"
                        >
                          Versión anterior
                      </CButton>
                    </>       
                :
                  <>
                    {base ?
                      <>
                        <CButton
                            className="btn-round btn-fill disabled"
                            href="#"
                            style={{ border: "2px solid blue",color:"blue"}}
                            variant="default"
                          >
                            Versión actual
                        </CButton>
                      </>
                    :
                      <>
                        <form>   
                            <script
                                src='https://checkout.epayco.co/checkout.js' 
                                type='text/javascript' 
                                data-epayco-key='844653286eae0c2c45035638bff830f8' 
                                class='epayco-button'   
                                data-epayco-amount='14' 
                                data-epayco-tax='0' 
                                data-epayco-tax-base='0'
                                data-epayco-name='Plan PREMIUM un mes' 
                                data-epayco-description='Plan PREMIUM un mes' 
                                data-epayco-currency='USD'
                                data-epayco-country='CO' 
                                data-epayco-test='true'
                                data-epayco-external='false' 
                                data-epayco-extra1={email} 
                                data-epayco-extra2={usuario}
                                data-epayco-extra3='PREMIUM' 
                                data-epayco-extra4='mensual' 
                                data-epayco-response='https://codeflex.com.co/drive/index.html' 
                                data-epayco-button='https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/premiumm.png'
                                data-epayco-confirmation='https://xo8cblasg3.execute-api.us-east-1.amazonaws.com/produccion/epayco' >
                            </script> 
                        </form>
                      </>
                    }
                  </>
                }
              </CTableDataCell>



            </CTableRow>
          </CTableBody>
        </CTable>
        </CCardBody>
      </CCard>

      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Pro;
